import React, { FC, ReactNode } from 'react';
import s from './Modal.module.scss';

type FooterProps = {
  children: ReactNode;
};

const Footer: FC<FooterProps> = ({ children }) => (
  <div className={s.footer}>
    {children}
  </div>
);

export default Footer;
